import { n__ } from '~/locale';
export default {
    name: 'FileRowStats',
    props: {
        file: {
            type: Object,
            required: true
        }
    },
    computed: {
        addedLinesLabel () {
            return n__('%d line added', '%d lines added', this.file.addedLines);
        },
        removedLinesLabel () {
            return n__('%d line removed', '%d lines removed', this.file.removedLines);
        }
    }
};
